import {
  Container,
  Title,
  Text,
  Stack,
  Paper,
  ThemeIcon,
  Box,
  Group,
  Button,
  Image,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconServer, IconDatabase, IconShield } from "@tabler/icons-react";
import { Footer } from "../components/Footer/Footer";
import { Header } from "./Header/Header";
import { nonProtectedRoutes } from "../utils/nonProtectedRoutingPaths";
const SecurityFeatures = [
  {
    icon: IconShield,
    title: "Enterprise-Grade AI",
    description:
      "Powered by secure AI infrastructure that never retains or trains on your data, unlike consumer AI platforms.",
    image: "/static/vertex2.png",
  },
  {
    icon: IconServer,
    title: "Trusted Cloud Infrastructure",
    description:
      "Powered by Google Cloud Platform, leveraging enterprise-grade security and reliability.",
    image: "/static/gcp.svg",
  },
  {
    icon: IconDatabase,
    title: "Comprehensive Data Protection",
    description:
      "Advanced encryption protocols protect your sensitive information both in transit and at rest.",
  },
  // {
  //   icon: IconLock,
  //   title: "Privacy-First Design",
  //   description: "Built to protect your data with secure data handling and encryption."
  // }
];

export default function Security() {
  const isMobile = useMediaQuery("(max-width: 48em)");
  const toggle = () => setOpened((o) => !o);

  return (
    <Box
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {Header()}
      <Container size="md" px={isMobile ? "xs" : "md"} py="xl">
        <Stack spacing="xl">
          <Title order={1} align="center">
            Security & Privacy
          </Title>

          <Text size="lg" align="center" maw={800} mx="auto">
            Socius is built with commercial-grade security to protect your
            sensitive data.
          </Text>

          <Group justify="center" gap="md" wrap="wrap">
            {SecurityFeatures.map((feature, index) => (
              <Paper
                key={index}
                w={isMobile ? "100%" : "700px"}
                mih={224}
                withBorder
                p="md"
                radius="md"
              >
                <Stack spacing="xs" align="center" ta="center" h="100%">
                  <ThemeIcon size={40} radius="md">
                    <feature.icon size={24} />
                  </ThemeIcon>
                  <Title order={3}>{feature.title}</Title>
                  <Text>{feature.description}</Text>
                  {feature.image && (
                    <Box
                      style={{ flex: 1, display: "flex", alignItems: "center" }}
                    >
                      <Image
                        src={feature.image}
                        w={120}
                        fit="contain"
                        my="lg"
                      />
                    </Box>
                  )}
                </Stack>
              </Paper>
            ))}
          </Group>

          <Group justify="center">
            <Button
              variant="light"
              size="md"
              component="a"
               href={nonProtectedRoutes.TERMS}
            >
              Learn more about our policies
            </Button>
          </Group>
        </Stack>
      </Container>
      <Footer />
    </Box>
  );
}
